import { ArrowForwardFilled, CheckmarkCircleFilled, SubtractCircleFilled, WarningFilled } from "@fluentui/react-icons";
import React from "react";
import { ValidationResults } from "../abstractions/EAppValidation";

export const ValidationTestCaseResultIcon: React.FC<{ result: ValidationResults; }> = ({ result }) => {
  switch (result) {
    case ValidationResults.Success:
      return <CheckmarkCircleFilled fontSize={24} color={getValidationIconColor(result)} />;
    case ValidationResults.Warning:
      return <WarningFilled fontSize={24} color={getValidationIconColor(result)} />;
    case ValidationResults.Error:
      return <SubtractCircleFilled fontSize={24} color={getValidationIconColor(result)} />;
    case ValidationResults.Skipped:
      return <ArrowForwardFilled fontSize={24} color={getValidationIconColor(result)} />;
    default:
      return <></>
  }
};

export const getValidationIconColor = (result: ValidationResults) => {
  switch (result) {
    case ValidationResults.Success:
      return "Green";
    case ValidationResults.Warning:
      return "Orange";
    case ValidationResults.Error:
      return "#CD5C5C";
    default:
      return "Gray";
  }
}
